import Vue from "vue";
import { BLOGS_LISTING , FETCH_BLOG_DETAIL } from "./actions.type";
import ApiService from "@/common/api.services";

const state = {};

const getters = {};

const actions = {
  [BLOGS_LISTING](state, params) {
    return ApiService.getWithParams("blogs", {
      params,
    })
      .then(({ data }) => {
        return data.response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  [FETCH_BLOG_DETAIL]({ commit }, { url, params }) {
    state.isLoading = true;
    return ApiService.getWithQueryParams(url, params)
      .then(({ data }) => {
        return data.response;
      })
      .catch((error) => {
        return error.response;
      });
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
